import _ from 'lodash';
import createModel, { prop } from './lib/create_model';
import createEnum from 'scripts/lib/create_enum';

export const ReactionType = createEnum('LOVE');

const MessageReaction = createModel({
  modelName: 'MessageReaction',
  properties: {
    // unicode of the emoji
    emoji: prop(String).default(null),
    // when emoji is not sent but a specific subset (so far just love, love is all you need)
    reaction: prop()
      .oneOf(..._.values(ReactionType))
      .default(null),
    timestamp: prop(String),
  },

  hasReaction() {
    return !!this.emoji || !!this.reaction;
  },

  statics: {
    create(attrs) {
      return new MessageReaction(attrs);
    },
  },
});

export default MessageReaction;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/message_reaction.js